import 'globals';

(function(window) {
	window.lazyLoadObject = new LazyLoad();
})(window);
